import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  titleSettingsCard: {
    letterSpacing: '0.1rem',
    textTransform: 'uppercase',
    color: theme.palette.primary.main,
    fontSize: '1.1rem',
    marginBottom: '10px',
    marginTop: '10px',
    width: '50%',
  },

  subtitleSettingsCard: {
    letterSpacing: '0.1rem',
    textTransform: 'uppercase',
    color: theme.palette.secondary.main,
    fontSize: '0.9rem',
  },

  icon_button: {
    height: '14px',
    width: '14px',
  },

  mainHeaderContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },

  cardHeader: {
    margin: 0,
    padding: '4px 16px !important',
  },

  action: {
    margin: 0,
  },

  listTitleItem: {
    letterSpacing: '0.1rem',
    display: 'flex',
    justifyContent: 'flex-start',
    color: theme.palette.texts.secondary,
    padding: '4px 8px',
    // borderBottom: `1px solid ${theme.palette.divider}`,
    // '&:nth-of-type(odd)': {
    //   background: theme.palette.background.lighterBg,
    // },
  },

  listItem: {
    display: 'flex',
    justifyContent: 'flex-start',
    borderBottom: `1px solid ${theme.palette.divider}`,
    fontSize: theme.fonts.responsiveMedium,
    letterSpacing: '0.1rem',
    color: theme.palette.texts.primary,
  },

  tableTitleItemsContainer: {
    letterSpacing: '0.1rem',
    display: 'flex',
    justifyContent: 'flex-start',
    color: theme.palette.texts.secondary,
    background: theme.palette.background.lighterBg,
  },

  listHeaderContainer: {
    background: theme.palette.background.lighterBg,
    padding: '0',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },

  institutionsHeaderContainer: {
    background: theme.palette.background.lighterBg,
    padding: '4px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },

  accordionSummary: {
    backgroundColor: theme.palette.background.lighterBg,
    minHeight: '38px',
    padding: '0 10px',
    '&.MuiAccordionSummary-content': {
      margin: 0,
    },
    '&.MuiAccordionSummary-content.Mui-expanded': {
      margin: 0,
    },
    '&.Mui-expanded': {
      minHeight: 48,
      borderRadius: '5px 5px 0 0',
    },
    '&.MuiIconButton-root': {
      padding: 4,
    },
  },

  accordionSummaryContent: {
    margin: 0,

    '&.MuiAccordionSummary-content': {
      margin: 0,
    },
    '&.MuiAccordionSummary-content.Mui-expanded': {
      margin: 0,
    },
    '&.Mui-expanded': {
      margin: 0,
    },
  },

  nodeDetailsContainer: {
    width: '100%',
  },

  nodeDetailsItems: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '0',
    width: '100%',
  },

  listHeaderName: {
    fontSize: theme.typography.h6.fontSize,
    letterSpacing: '0.1rem',
    textTransform: 'uppercase',
    color: theme.palette.texts.primary,
    marginLeft: '10px',
    fontWeight: 'bold',
  },

  listHeaderNameSummary: {
    fontSize: theme.typography.h6.fontSize,
    letterSpacing: '0.1rem',
    textTransform: 'uppercase',
    color: theme.palette.texts.primary,
    fontWeight: 'bold',
  },

  textField: {
    margin: '0 10px',
    width: '90%',
  },

  listHeader: {
    fontSize: theme.fonts.responsiveMediumSmall,
    letterSpacing: '0.1rem',
    color: theme.palette.texts.primary,
    color: theme.palette.primary.main,
  },

  tableListHeader: {
    background: theme.palette.background.lighterBg,
    fontSize: theme.fonts.responsiveMedium,
    letterSpacing: '0.1rem',
    color: theme.palette.texts.primary,
    fontWeight: 'bold',
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',
  },

  listContainer: {
    width: '100%',
    minHeight: '100%',
    maxWidth: '100%',
    whiteSpace: 'pre',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },

  buttonGeneral: {
    minWidth: '100px',
    height: '21px',
    minHeight: '21px',
    margin: '3px',
    fontSize: theme.fonts.responsiveSmall,
  },

  editButton: {
    color: 'white',
    backgroundColor: theme.palette.accents.dark,
    '&:hover': {
      background: `${theme.palette.accents.main} !important`,
      boxShadow: '0px 0px 5px 0px #d7c2c2',
    },
  },

  deleteButton: {
    color: 'white',
    border: `1px solid #a9a9a9`,
    '&:hover': {
      background: `${theme.palette.accents.main} !important`,
      boxShadow: '0px 0px 5px 0px #d7c2c2',
      border: `1px solid ${theme.palette.accents.main}`,
    },
  },

  nodeDetailsItem: {
    display: 'flex',
    padding: '4px 8px',
    width: '100%',
  },

  chipMode: {
    background: theme.palette.background.lighterBg,
    borderRadius: '40px',
    padding: '2px 4px',
    fontSize: theme.fonts.responsiveSmall,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '80%',
  },

  modulesContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    padding: '12px',
    borderRadius: '5px',
    margin: '10px 0',
    backgroundColor: 'rgb(76, 76, 76)',
    minHeight: '170px',
  },

  institutionsContainer: {
    padding: '0',
    margin: '10px 0',
    minHeight: '100px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },

  dialogTitleContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },
  ruleRowContainer: {
    padding: '2px 10px 8px 10px',
    maxWidth: '100%',
  },

  nodeTitles: {
    fontSize: theme.fonts.responsiveMedium,
    letterSpacing: '0.1rem',
    color: theme.palette.texts.primary,
    fontWeight: 'bold',
    maxWidth: '35%',
    whiteSpace: 'break-spaces',
    overflow: 'hidden',
  },

  nodeValues: {
    fontSize: theme.fonts.responsiveMedium,
    letterSpacing: '0.1rem',
    color: theme.palette.texts.primary,
    whiteSpace: 'pre',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },

  gridItemCenter: {
    display: 'flex',
    alignItems: 'center',
    height: '40px',
  },
  gridItemEnd: {
    display: 'flex',
    alignItems: 'center',
    height: '40px',
    justifyContent: 'center',
  },

  iconButtonSize: {
    width: 28,
    height: 28,
    minWidth: 28,
    minHeight: 28,
  },

  addRuleFabContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
    padding: '0 10px',
  },

  addRuleFab: {
    width: 28,
    height: 28,
    minWidth: 28,
    minHeight: 28,
  },
  deleteIcon: {
    width: 18,
    height: 18,
    minWidth: 18,
    minHeight: 18,
    fill: 'white',
  },
  deleteIconDisabled: {
    opacity: 0.5,
  },
  deleteIconEnabled: {
    opacity: 1,
  },

  customWidth: { maxWidth: 700 },

  send_report_main_container: {
    display: 'flex',
    flexDirection: 'column',
    width: '650px',
  },

  send_report_img_container: {
    display: 'flex',
    gap: '4px',
    marginTop: '20px',
    padding: '10px',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'flex-start',
    overflowX: 'auto',
  },

  manual_report_type_container: {
    width: '20%',
    minWidth: '120px',
    height: '280px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '6px',
    border: '1px solid gray',
  },

  report_title: {
    fontSize: '14px',
    fontWeight: 600,
    textAlign: 'center',
    marginBottom: '4px',
  },

  report_explanation: {
    fontSize: '12px',
    textAlign: 'center',
    marginBottom: '6px',
    minHeight: '32px',
    whiteSpace: 'normal',
  },

  img_container: {
    height: '150px',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  img_style: {
    width: '95%',
    height: 'auto',
    maxHeight: '100%',
    objectFit: 'contain',
    boxShadow: '0px 0px 5px 1px rgb(51 51 51)',
  },

  title_header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },

  report_settings_container: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: '8px',
  },

  report_checks: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    padding: '0 4px',
  },

  report_fields: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '12px 16px',
    width: '100%',
    padding: '4px 12px 8px',
    alignItems: 'start',
  },

  cards_wrapper: {
    display: 'flex',
    gap: '8px',
    marginBottom: 8,
    width: '100%',
  },

  card_split_container: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '8px',
  },

  reports_section_container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    width: '100%',
    padding: '8px',
  },

  priors_section_container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    width: '100%',
    padding: '8px',
  },

  header_container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },

  priors_limits_container: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    width: '100%',
    padding: '0 12px',
    gap: '12px',
  },

  priors_limits_container_item: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    width: '50%',
  },

  priors_other_value_container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    width: '40%',
  },

  priors_select_container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    marginBottom: '8px',
    gap: '8px',
    paddingTop: '8px',
  },

  priors_select_label: {
    marginRight: '8px',
    width: '60%',
  },

  split_: {
    marginBottom: 8,
    display: 'flex',
    justifyContent: 'space-between',
  },

  title_margin: {
    marginLeft: '12px',
  },

  select_label_margin: {
    marginLeft: '14px',
  },

  routing_tag_section: {
    width: '100%',
    padding: '8px 12px 4px',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },

  routing_tag_row: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    width: '100%',
  },

  routing_tag_kind: {
    minWidth: 180,
    maxWidth: 240,
  },

  routing_tag_field: {
    flex: 1,
    minWidth: 0,
  },

  routing_tag_helper: {
    color: theme.palette.text.secondary,
  },

  priors_checkbox_label: {
    width: '50%',
    margin: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginRight: '12px',
  },

  label_explanation: {
    marginBottom: '8px',
  },

  select_with_other_form_control: {
    width: '80%',
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: '8px',
  },

  select_with_other_select: {
    width: '100%',
  },

  select_with_other_select_other: {
    width: '50%',
  },
}));
